import { Outlet } from 'react-router-dom';

export const VisitorOutlet = () => <Outlet />;
